import React from "react";
import { Segment, Button, Divider, Header, Message } from "semantic-ui-react";
import { Trans } from "react-i18next";
export const CreateHotel = props => {
  return (
    <React.Fragment>
      <Message info>
        <Message.Content>
          <Trans i18nKey="message:welcomeMessageText">
            <Message.Header>Witaj w HotelCleanApp!</Message.Header>
            Miło, że z nami jesteś. Możesz teraz zarządzać czystością swojego
            obiektu. Masz dwie możliwości:
            <Message.List>
              <Message.Item>
                Klikając <strong>Create hotel</strong>, samodzielnie dodasz pokoje w programie,
                a aplikacja będzie działała niezależnie.
              </Message.Item>
              <Message.Item>
                Klikając <strong>Synchronize with KWHotel</strong>, połączysz aplikację ze
                swoim programem. Pokoje zostaną pobrane automatycznie, a statusy
                czystości będą na bieżąco aktualizowane.
              </Message.Item>
            </Message.List>
          </Trans>
        </Message.Content>
      </Message>
      <Header as="h1">{props.t("hotel:hotelWizardText")}</Header>
      <Segment>
        <Button
          primary
          fluid
          onClick={() => props.history.push("/hotel/create")}>
          {props.t("hotel:createHotelText")}
        </Button>
        <Divider horizontal>{props.t("hotel:orText")}</Divider>
        <Button
          color="orange"
          fluid
          onClick={() => props.history.push("/hotel/synchronize")}>
          {props.t("hotel:synchronizeWithKWHotelText")}
        </Button>
      </Segment>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/hotels/CreateHotel/CreateHotel.js